/* eslint-disable react/jsx-no-target-blank */
import { Heading } from '../../components/Heading';
import { Plan } from '../../components/Plan';
import * as S from './styles';

import { api } from 'services/api';
import { useContext, useEffect, useMemo, useState } from 'react';

import { Loading } from 'components/Loading';
import moment from 'moment';
import 'moment-timezone';
import { buildPlanPrice, capitalizeFirstLetter } from 'helpers/util';
import { MainHeader } from 'components/MainHeader';
import { BaseMain } from 'components/BaseMain';
import WarningTriangle from 'components/Icons/WarningTriangle';
import { Banner } from 'components/Banner';
import {
  CaretDoubleUp,
  CollectionIcon,
  DocumentData,
  InfoIcon,
  KenloIcon,
  KenloLiaIcon,
  PencilSignature,
} from 'components/Icons';
import { PlanCustomContext } from 'contexts/PlanCustomContext';
import { FeatureContext } from 'contexts/FeaturesContext';
import { QualificationContext } from 'contexts/AvailableQualification';
import { NotificationBannerContext } from 'contexts/NotificationBannerContext';
import { ClientInfoContext } from 'contexts/ClientInfoContext';
import ResponsiveTable from 'components/ResponsiveTable/ResponsiveTable';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import SubHeader from 'components/SubHeader/SubHeader';
import DataAgency from 'components/Drawers/DataAgency/DataAgency';
import { formatCurrency } from 'pages/PlanDetails';
import AddEnvelopes from 'components/Drawers/KenloSubscriptionBenefits/AddEnvelopes';
import DataHistory from 'components/Drawers/DataHistory/DataHistory';
import { FreshDeskLoader } from 'components/FreshDesk/FreshDesk';

export type signaturesDataProps = {
  id_plan: number;
  name: string;
  plan: {
    name: string;
  };
  status: string;
  frequency: string;
  terminationDate: string;
  totalCost: string;
  finalValue: string;
  //typeProduct: string;
};

type InvoicesBillingsProps = {
  id_billing: string;
  id_invoice: string;
};

export type lastsInvoicesProps = {
  invoices_billings: any;
  issuanceDate: string;
  invoiceMonth: string;
  compo_billing: [{ name: string }];
  value: string;
  paidValue: string;
  dueDate: string;
  status: string;
  id_billing: string;
  id_typePay: number;
  creditCardNumber: string;
  paymentDate: string;
  description: string;
};

type lastsInvoicesProps2 = {
  invoices_billings: InvoicesBillingsProps[];
  invoiceMonth: string;
  issuanceDate: string;
  value: string;
  paidValue: string;
  dueDate: string;
  status: string;
  description: string;
  id_billing: string;
  id_typePay: number;
  creditCardNumber: string;
  paymentDate: string;
  hasCompoBilling: boolean;
};

export type PlansProps = {
  id_signature: number;
  id_plan: number;
  name: string;
  plan: {
    name: string;
  };
  status: string;
  totalCost: string;
  terminationDate: string;
  frequency: string;
  finalValue: string;
  costMonthly?: string;
};

type DataValidateStatusProps = {
  status: string;
};

export const ClientArea = () => {
  const [onDataAgency, setOnOpenDataAgency] = useState(false);
  const [onDataHistory, setOnOpenDataHistory] = useState(false);

  const [counterBillingsStatus, setCounterBillingsStatus] = useState(0);
  const [loadingTable, setLoadingTable] = useState(false);
  const [isOpenDrawerBenefits, setIsOpenDrawerBenefits] = useState(false);
  const [lastsInovices, setLastsInvoices] = useState<lastsInvoicesProps2[]>([]);
  const [plans, setPlans] = useState<PlansProps[]>([]);
  const [idInternalProduct, setIdInternalProduct] = useState<number>();
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  const [dataValidateStatus, setDataValidateStatus] = useState<
    DataValidateStatusProps[]
  >([]);
  const [filter, setFilter] = useState('vencida');
  const history = useCustomUtilsHistory();
  const { dataAgency } = useContext(FeatureContext);
  const { dataClientInfo } = useContext(ClientInfoContext);
  const { handleSetIdSignature } = useContext(PlanCustomContext);
  const { fetchDataQualifierBalance } = useContext(QualificationContext);
  const { setDataBanner, dataBanner } = useContext(NotificationBannerContext);
  const [statusProduct, setStatusProduct] = useState(false);

  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  // const idClientImob = localStorage.getItem('useImobId');
  const [showButton, setShowButton] = useState(() => {
    const storedValue = localStorage.getItem('showProducts');
    return storedValue !== 'false';
  });

  const handleShowProducts = () => {
    const newShowButton = !showButton;
    localStorage.setItem('showProducts', newShowButton.toString()); // Salva o valor como string
    setShowButton(newShowButton);
  };
  const [arrMsgBanner, setArrMsgBanner] = useState<any[]>([]);

  const verificaAssinaturasVencendo = (arrAssinaturas: any[]): any[] => {
    const arrMsg: any[] = [];
    if (Array.isArray(arrAssinaturas)) {
      arrAssinaturas.map((item: any) => {
        if (
          item.frequency == 'anual' &&
          item.terminationDate != null &&
          (item.typeProduct === 'imob' ||
            item.typeProduct === 'locacao' ||
            item.typeProduct === '')
        ) {
          const dateFimMoment = moment.tz(
            item.terminationDate,
            'America/Sao_Paulo',
          );
          const dateNow = moment();
          const dias = dateFimMoment.diff(dateNow, 'days');

          if (
            dias <= 30 &&
            dias >= 0 &&
            dateFimMoment.clone().subtract(1, 'days').format('YYYY-MM-DD') >=
              moment(new Date()).format('YYYY-MM-DD')
          ) {
            const dateStr = dateFimMoment
              .clone()
              .subtract(1, 'days')
              .format('DD/MM/YYYY');
            let typeProduct = item.typeProduct;
            const originalTypeProduct = item.typeProduct;
            if (typeProduct === 'locacao') {
              typeProduct = 'locação';
            }
            if (typeProduct === '') {
              typeProduct = 'produto';
            }
            const msg = `O ${item.plan.name} <b>termina ${
              dias === 0 ? 'hoje' : `em ${dias} dia${dias > 1 ? 's' : ''}`
            }</b> (${dateStr}). Para não perder acesso ao produto Kenlo ${capitalizeFirstLetter(
              typeProduct,
            )} faça a renovação.`;
            const obj = {
              id: item.id_signature,
              originalTypeProduct: originalTypeProduct,
              typeProduct: originalTypeProduct,
              msg: msg,
            };
            arrMsg.push(obj);
          }
        }
      });
    }
    return arrMsg;
  };
  const setValorMensalAssinatura = (signatures: any[] = []): any[] => {
    signatures = signatures.map((item: any) => {
      item['costMonthly'] = item['finalValue'];
      if (item.frequency == 'mensal') return item;
      if (item.frequency == 'anual' && item.finalValue > 0) {
        item['costMonthly'] = (parseFloat(item['finalValue']) / 12).toFixed(2);
      }
      return item;
    });
    return signatures;
  };

  useEffect(() => {
    if (
      Number(dataClientInfo?.id_client) > 0 &&
      dataClientInfo?.accessTokenParam &&
      dataClientInfo?.id_realstate
    ) {
      dataAgency &&
        fetchDataQualifierBalance(
          dataClientInfo?.accessTokenParam,
          dataClientInfo?.idTokenParams,
        );
    }
  }, [fetchDataQualifierBalance, dataAgency, dataClientInfo]);

  useEffect(() => {
    const fetchValidateCondition = async () => {
      try {
        const { data } = await api.get(
          `qualifier/bought/pending/${dataClientInfo?.id_realstate}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setDataValidateStatus(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    if (dataClientInfo?.id_realstate) {
      fetchValidateCondition();
    }
  }, [accessToken, dataClientInfo?.id_realstate, idToken]);

  useEffect(() => {
    handleSetIdSignature(plans[0]?.id_signature);
  }, [handleSetIdSignature, plans]);

  useEffect(() => {
    if (accessToken && idToken) {
      //fetchDataAgency();
      fetchDataPlan();
      fetchDataBillings();
      fetchComplementaryProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, idToken]);

  const fetchDataPlan = async () => {
    try {
      const { data } = await api.get('client/signatures', {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      setPlans(setValorMensalAssinatura(data.data));
      setArrMsgBanner(verificaAssinaturasVencendo(data.data));
    } catch (error) {
      console.log(error);
    }
  };
  const [complementaryProducts, setComplementaryProducts] = useState<any[]>([]);
  const fetchComplementaryProducts = async () => {
    try {
      const { data } = await api.get('products', {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      setIsLoading(false);
      setComplementaryProducts(
        data.data.filter((item: any) => !item.is_hidden),
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(true);
  };
  const { myProducts, complements } = useMemo(() => {
    if (!complementaryProducts) return { myProducts: [], complements: [] };

    // Definindo explicitamente os tipos das chaves de links
    const links: Record<
      | 'Kenlo Leads'
      | 'Kenlo Locação'
      | 'Kenlo Imob'
      | 'Kenlo Inteligência'
      | 'Kenlo Assinaturas'
      | 'LYA',
      string
    > = {
      'Kenlo Leads': `/QualifierDetails/${dataAgency?.id_client}/details`,
      'Kenlo Locação': `/KenloLocation/1`,
      'Kenlo Imob': `/planDetails/1`,
      'Kenlo Inteligência': '/KenloIntelligence',
      'Kenlo Assinaturas': `/KenloSignature/${dataAgency?.id_client}/details`,
      LYA: `/LYA/${dataAgency?.id_client}/details`,
    };

    // Função para mapear o produto com base no status
    const mapProduct = (el: any, isActive: boolean) => ({
      ...el,
      // Verifica se o nome de el é uma chave válida de links
      link: isActive
        ? links[
            el.name as
              | 'Kenlo Leads'
              | 'Kenlo Locação'
              | 'Kenlo Imob'
              | 'Kenlo Inteligência'
              | 'LYA'
          ]
        : el.landingPage,
      linkStyle: isActive ? 'status-link' : 'complement-link',
    });

    // Dividindo os produtos conforme o status
    const myProducts = complementaryProducts
      .filter(el => el.status)
      .map(el => mapProduct(el, true));
    const complements = complementaryProducts
      .filter(el => !el.status)
      .map(el => mapProduct(el, false));

    return { myProducts, complements };
  }, [complementaryProducts, dataAgency?.id_client]);

  const signatureById = useMemo(() => {
    const map: Record<string, PlansProps> = {};
    plans?.forEach(plan => {
      if (plan?.id_signature) map[String(plan.id_signature)] = plan;
    });
    return map;
  }, [plans]);

  const fetchDataBillingsStatus = async () => {
    try {
      const response = await api.get(`client/billings?status=vencida`, {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      const data = response.data.data;
      setCounterBillingsStatus(data.length);
      setFilter(data.length > 0 ? 'vencida' : 'paga');
    } catch (error) {
      console.log(error);
    }
  };
  const fetchDataProductsStatus = async () => {
    try {
      const response = await api.get(`/status/operation-status`, {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      const data = response.data.data.openIncidents;
      setStatusProduct(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDataBillingsStatus();
    fetchDataProductsStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fetchDataBillings();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const fetchDataBillings = async () => {
    try {
      setLoadingTable(true);
      // const dateInitial = moment().subtract(12, 'M').format('YYYY-MM-DD');
      // const dateFinal = moment().add(45, 'days').format('YYYY-MM-DD');
      const response = await api.get(
        `client/billings?page=1&limit=10&sort=desc&status=${filter}`,
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      const data = response.data.data;
      setLastsInvoices(data);
      setLoadingTable(false);
    } catch (error) {
      setLoadingTable(false);
      console.log(error);
    }
  };
  const descriptions: any = {
    1: 'A maior plataforma de negócios imobiliários da América Latina.',
    2: 'Simplifique sua operação imobiliária com menos papel e mais tecnologia.',
    3: 'Conheça o gestor de leads mais completo do mercado imobiliário.',
    6: 'Transforme dados em decisões. Transforme decisões em resultados.',
    7: `Feche contratos digitais com segurança jurídica e mais agilidade.`,
    11: 'A primeira IA que qualifica leads, cria descrições, anima imóveis e gera conteúdo.',
  };
  const icons: any = {
    1: <KenloIcon />,
    2: <KenloIcon />,
    3: <CaretDoubleUp />,
    6: <DocumentData />,
    7: <PencilSignature />,
    11: <KenloLiaIcon />,
  };
  useEffect(() => {
    // Check if we're coming back from a reload
    const redirectPath = sessionStorage.getItem('redirectPath');
    if (redirectPath) {
      // Clear the stored path
      sessionStorage.removeItem('redirectPath');
      // Navigate to the stored path if needed
      if (redirectPath !== window.location.pathname) {
        history.push(redirectPath);
      }
    }
  }, [history]);
  return (
    <>
      <MainHeader />
      <SubHeader
        title={dataAgency?.name}
        noHasReturn
        onClickDataAgency={() => setOnOpenDataAgency(true)}
        onClickHistory={() => setOnOpenDataHistory(true)}
        status={
          <S.StatusContainer>
            {counterBillingsStatus > 0 && (
              <S.Status
                backgroundColor='#F9EFDF'
                onClick={() =>
                  history.push(`/HistoryOfInvoices/${plans[0]?.id_signature}`)
                }
              >
                <InfoIcon />
                <span>
                  {counterBillingsStatus} fatura
                  {counterBillingsStatus > 1 && 's'} em aberto
                </span>
              </S.Status>
            )}

            {statusProduct && (
              <S.Status
                backgroundColor='#F9EFDF'
                onClick={() =>
                  window.open(`https://status.kenlo.com.br/client/`, '_blank')
                }
              >
                <InfoIcon />
                <span>Sistema com instabilidade</span>
              </S.Status>
            )}
          </S.StatusContainer>
        }
      />
      {!isLoading && <Loading />}
      <BaseMain>
        {arrMsgBanner.map((item, index) => (
          <>
            <S.WrapperBanners>
              <Banner
                key={index}
                icon={<WarningTriangle />}
                button
                text={item.msg}
                id={item.id}
                typeProduct={item.typeProduct}
              />
            </S.WrapperBanners>
          </>
        ))}
        {dataBanner && (
          <S.WrapperBanners>
            <Banner
              icon={<WarningTriangle />}
              text='O boleto do novo pacote contratado já está disponível. O saldo de qualificações será atualizado assim que recebermos o pagamento.'
            >
              <a
                href={dataBanner.link2via}
                target='_blank'
                onClick={() => setDataBanner(undefined)}
              >
                Ver boleto
              </a>
            </Banner>
          </S.WrapperBanners>
        )}

        <S.WrapperPlan>
          <S.ElementWrapper>
            <Heading
              title='Meus produtos'
              size='large'
              weight='600'
              color='#1A1A1A'
            />
          </S.ElementWrapper>
          <S.contentMyProducts>
            {myProducts?.map((el, index) => {
              const planPrice = buildPlanPrice(
                el?.planFrequency,
                el?.installmentValue,
                signatureById[String(el?.id_signature)],
              );
              return (
                <Plan
                  key={`myProducts-${index}`}
                  title={el.name}
                  type='myProducts'
                  subTitle={
                    planPrice.period
                      ? `${formatCurrency(planPrice.value)} / ${
                          planPrice.period
                        }`
                      : formatCurrency(planPrice.value)
                  }
                  status={el.status}
                  planType={el?.planName}
                  link={el.link}
                />
              );
            })}
          </S.contentMyProducts>
          {complements.length > 0 && (
            <>
              <hr style={{ margin: '24px -24px' }} />
              <S.ElementWrapper>
                <S.Title>
                  <CollectionIcon />
                  <Heading
                    title='Complemente sua experiência'
                    size='medium'
                    weight='600'
                    color='#1A1A1A'
                  />
                </S.Title>
                <S.ShowButton onClick={handleShowProducts}>
                  {showButton ? 'ocultar' : 'Ver produtos'}
                </S.ShowButton>
              </S.ElementWrapper>
              {showButton && (
                <S.ScrollableWrapper>
                  {complements?.map((el, index) => (
                    <Plan
                      key={`complements-${index}`}
                      title={el.name}
                      description={descriptions[el.id]}
                      icon={icons[el.id]}
                      id={el.id}
                      link={el.landingPage}
                      setIsOpenDrawer={() => {
                        setIdInternalProduct(el.id);
                        setIsOpenDrawerBenefits(true);
                      }}
                    />
                  ))}
                </S.ScrollableWrapper>
              )}
            </>
          )}
        </S.WrapperPlan>
        <S.Wrapper>
          <ResponsiveTable
            value={lastsInovices.filter(el => el.status === filter).slice(0, 3)}
            loadingTable={loadingTable}
            filter={filter}
            setFilter={setFilter}
            showHeader
            linkHeader={() =>
              history.push(`/HistoryOfInvoices/${plans[0]?.id_signature}`)
            }
          />
        </S.Wrapper>
      </BaseMain>
      {onDataAgency && (
        <DataAgency closeDrawer={() => setOnOpenDataAgency(false)} />
      )}
      {onDataHistory && (
        <DataHistory closeDrawer={() => setOnOpenDataHistory(false)} />
      )}
      {isOpenDrawerBenefits && (
        <AddEnvelopes
          closeDrawer={() => setIsOpenDrawerBenefits(false)}
          idInternalProduct={idInternalProduct}
        />
      )}
      {isLoading && dataAgency && <FreshDeskLoader />}
    </>
  );
};
